import React, { useEffect } from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import TextField from "@material-ui/core/TextField";
// import Slider from "./slider";
import DateTime from "./datetimepicker";
import Button from "@material-ui/core/Button";
import Input from "@material-ui/core/Input";
import Checkbox from "@material-ui/core/Checkbox";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import CircularProgress from "@material-ui/core/CircularProgress";
import ListItemText from "@material-ui/core/ListItemText";

import Colors from "./../../Global/colors";
import DarkButton from "./../../Global/DarkButton";
import Slider from "@material-ui/core/Slider";

import "../../index.css";
var _colorManipulator = require("../../../node_modules/@material-ui/core/styles/colorManipulator");
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
    color:'#043077',
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  controlContainerStyle: {
    flex: 1,
    flexDirection: "column",
    //width:'100%',
  },
  controltyle: {
    marginBottom: 10,
    //borderBottomWidth:'thin',
    //border: '0px solid green', borderBottomColor: 'gray'
  },
  panelStyle: {
    backgroundColor: '#eaf7fe',
    borderRadius: 2.5,
  },
  header: {
    backgroundColor: Colors.backgroundColor,
  },
  labelStyle: {
    textAlign: "left",
    color: "black",
    fontSize: 15,
    fontFamily: "ProductSans",
    fontWeight: "500",
  },
  textBoxStyle: {
    fontWeight: "bold",
    paddingLeft: theme.spacing.unit,
  },
  textField: {
    width: "90%",
    marginLeft: "auto",
    marginRight: "auto",
    paddingBottom: 0,
    marginTop: 0,
    fontWeight: 500,
  },
  input: {
    color: "black",
  },
  buttonDivStyle: {
    textAlign: "left",
    color: "black",
    fontSize: 18,
    marginBottom: 5,
    alignSelf: "center",
    display: "flex",
    justifyContent: "center",
  },
  buttonStyle: {
    alignSelf: "center",
    display: "flex",
    justifyContent: "center",
    width: 150,
  },
}));
const DrawControl = (props) => {
  const classes = useStyles();
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 48 * 4.5 + 8,
        width: 250,
      },
    },
  };


  React.useEffect(() => {}, [props.item.dataType, props.item.title])
  return (
    <div className={classes.controltyle}>
      {props.item.dataType == "Text field" && (
        <div style={{ display: "flex", flexDirection: "column" }}>
          {/* <label for="country" className={classes.labelStyle}>{props.item.title}</label> */}
          <Typography className={classes.labelStyle}>
            {props.item.mandatory ? "*" + props.item.title : props.item.title}
          </Typography>
          <TextField
            id={props.item.id}
            className={["customField", { className: classes.textBoxStyle }]}
            InputProps={{
              className: classes.textBoxStyle,
            }}
            variant="outlined"
          />
        </div>
      )}

      {props.item.dataType == "Checkbox" && (
        <div>
          <label style={{ display: "flex", flexDirection: "row" }}>
            <Typography className={classes.labelStyle}>
              {props.item.mandatory ? "*" + props.item.title : props.item.title}
            </Typography>
            <input type="checkbox" />
            <span className={classes.labelStyle} />
          </label>
        </div>
      )}
      {props.item.dataType == "Anotation" && (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Typography className={classes.labelStyle}>
            {props.item.mandatory ? "*" + props.item.title : props.item.title}
          </Typography>
          <button class="btn waves-effect waves-light">Anotation</button>
        </div>
      )}

      {props.item.dataType == "Slider" && (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Typography className={classes.labelStyle}>
            {props.item.mandatory ? "*" + props.item.title : props.item.title}
          </Typography>
          <div className="container">
            <Slider
              onChange={(e, value) => null}
              style={{ marginLeft: "10%" }}
              min={0}
              max={10}
            />
          </div>
        </div>
      )}

      {props.item.dataType == "DateTime" && (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Typography className={classes.labelStyle}>
            {props.item.mandatory ? "*" + props.item.title : props.item.title}
          </Typography>
          <DateTime />
        </div>
      )}

      {props.item.dataType == "Number" && (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Typography className={classes.labelStyle}>
            {props.item.mandatory ? "*" + props.item.title : props.item.title}
          </Typography>
          <TextField
            id={props.item.id}
            className={["customField", { className: classes.textBoxStyle }]}
            InputProps={{
              className: classes.textBoxStyle,
            }}
            type="number"
            variant="outlined"
          />
        </div>
      )}

      {props.item.dataType == "Multi-Text" && (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Typography className={classes.labelStyle}>
            {props.item.mandatory ? "*" + props.item.title : props.item.title}
          </Typography>
          <TextField
            id={props.item.id}
            className={["customField", { className: classes.textBoxStyle }]}
            InputProps={{
              className: classes.textBoxStyle,
            }}
            multiline
            rowsMax={4}
            type="number"
            variant="outlined"
          />
        </div>
      )}

      {props.item.dataType == "Location" && (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Typography
            className={classes.labelStyle}
            style={{ fontFamily: "ProductSans" }}
          >
            {props.item.mandatory ? "*" + props.item.title : props.item.title}
          </Typography>
          <TextField
            id={props.item.id}
            className={["customField", { className: classes.textBoxStyle }]}
            InputProps={{
              className: classes.textBoxStyle,
            }}
            multiline
            rowsMax={4}
            type="number"
            variant="outlined"
          />
        </div>
      )}

      {props.item.dataType == "Custom" && (
        <div
          className={classes.controlContainerStyle}
          style={{ display: "flex", flexDirection: "column" }}
        >
          <Typography className={classes.labelStyle}>
            {props.item.mandatory ? "*" + props.item.title : props.item.title}
          </Typography>

          {!props.item.multiselection ? (
            props.item.responseLibrary?.responses.map((response) => {
              return (
                <div className={classes.buttonDivStyle}>
                  <span className={classes.buttonStyle}>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.buttonStyle}
                    >
                      {response.title}
                    </Button>
                  </span>
                </div>
              );
            })
          ) : (
            <div style={{ margin: 5, minWidth: 150 }}>
              <Select
                multiple
                fullWidth
                value={[]}
                name="PermissionData"
                //onChange={(e, v) => setSelectedSites(e.target.value)}
                input={<Input />}
                //renderValue={(selected) =>
                //selected.map((item) => item.title).join(", ")
                //}
                MenuProps={MenuProps}
                variant="outlined"
              >
                {props.item.responseLibrary.responses.map((name) => (
                  <MenuItem key={name.id} value={name}>
                    <Checkbox checked={[].indexOf(name) > -1} />
                    <ListItemText primary={name.title} />
                  </MenuItem>
                ))}
              </Select>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
const Section = (props) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  var list =
    props.section.checklist.list != undefined
      ? props.section.checklist.list
      : [];
  return (
    <div className={classes.root}>
      <ExpansionPanel
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
        className="customexpansion"
      >
        <ExpansionPanelSummary
          expandIcon={
            <ExpandMoreIcon
              className="expandcolor"
              style={{ color: Colors.globalColor8 }}
            />
          }
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          className={classes.panelStyle}
        >
          <Typography className={classes.heading}>
            {props.section.title}
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.controlContainerStyle}>
          {list
            .filter((v) => v.status !== "deleted")
            .map((item) => {
              return <DrawControl item={item} />;
            })}
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </div>
  );
};
const ControlledExpansionPanels = (props) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const [items, setItems] = React.useState([]);
  const fillTemplate = () => {
    var list = [];
    if (props.HOCprops.template != undefined)
      list = [...props.HOCprops.template];
    else list = [...props.HOCprops];

    //alert(JSON.stringify(props.HOCprops))
    setItems(list);
  };
  React.useState(
    () => {
      fillTemplate();
    },
    [props.HOCprops.template]
  );
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  var template_demo = [];
  if (props.HOCprops.template != undefined)
    template_demo = [...props.HOCprops.template];
  else template_demo = [...props.HOCprops];

  return (
    <div className={classes.root}>
      {template_demo.length == 0 && <div style={{ width:"100%", padding:'20px', textAlign: "center" }}>
                          <CircularProgress style={{ color: Colors.globalColor8 }} />
                        </div>}
      {template_demo?.map((item) => {
        if (item.status == "deleted") return;
        return (
          <Section
            props={props}
            section={item}
            setType={props.setType}
            onUpdateChecklist={props.onUpdateChecklist}
          />
        );
      })}
    </div>
  );
};
export default ControlledExpansionPanels;
